import ApplyResultSample from '@components/common/applyResultSample';
import GradeInfo from '@components/phs/pst/results/result/gradeInfo';
import ResultInfo from '@components/phs/pst/results/result/resultInfo';
import Warning from '@components/phs/pst/results/result/warning';
import { useMatchProfilesComplete } from '@repository/profiles/useProfile';
import { useGetMatchConfigStatus } from '@repository/match';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { usePHSPSTResults } from '@repository/phs/pst/usePhsPst';
import classnames from 'classnames/bind';
import styles from './pstResult.module.scss';

const cx = classnames.bind(styles);

// 내 프로필 > 개발자 검사 결과 > 개발구현능력 검사
interface PstResultProps {
  sn: number;
}

const PstResult = ({ sn }: PstResultProps) => {
  const { data: userInfo } = useUserInfo();
  const isLogin = !!userInfo?.id;
  const { data: ProfilesCompleteInfoData } = useMatchProfilesComplete();
  const { data: matchingConfig } = useGetMatchConfigStatus(isLogin);
  const isCompleteMatchingInfo =
    ProfilesCompleteInfoData?.profileRequiredCompleteYn && matchingConfig?.matchingConfigYn;

  const { data: pstResult } = usePHSPSTResults(sn, !!(sn && isCompleteMatchingInfo));

  //프로필 기본 미 완성시 or 추천 서비스 on이 아닐 경우
  if (!ProfilesCompleteInfoData || !matchingConfig) return null;
  if (!isCompleteMatchingInfo) return <ApplyResultSample isPst={true} />;
  if (!pstResult) return null;

  return (
    <div className={cx('resultArea')}>
      {/* [D] 달성 등급 */}
      <GradeInfo pstResult={pstResult} />

      {/* [D] 검사 결과 및 제출 히스토리 */}
      <ResultInfo pstResult={pstResult} />

      {/* [D] 경고 */}
      <Warning />
    </div>
  );
};

export default PstResult;
